// extracted by mini-css-extract-plugin
module.exports = {"article":"article___3eZMa","hasStickyVideo":"hasStickyVideo___3da5E"};